import axios from "axios";

const API_URL = process.env.VUE_APP_API_URL;

export const apiPublic = axios.create({
    baseURL: API_URL,
    withCredentials: true,
});
